import { useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet';
import ApplicationLayout from '../../../layouts/ApplicationLayout';
import TapIcon from '../../../services/TapIcon';
import { useSelector } from 'react-redux';
import HttpAPICall from '../../../services/HttpAPICall';
import { toast } from 'react-toastify';
import { BACKOFFICE_BASE_URL } from '../../../services/TapApiUrls';
import InputManufacturerSearch from '../../includes/ui/InputManufacturerSearch';

const IotModelAdd = ({ history, location }) => {
    const access_token = useSelector(state => state.auth.access_token);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [formData, setFormData] = useState({
        id: "",
        name: "",
        manufacturer_id: ""
    });
    const [selectedManufacturer, setSelectedManufacturer] = useState(null);
    const [isEditMode, setIsEditMode] = useState(false);

    const backToListing = () => {
        history.push({ pathname: '/model' });
    };

    useEffect(() => {
        initialFormData();
    }, []);

    const initialFormData = () => {
        if (location?.state?.editModelData) {
            const editData = location.state.editModelData;
            
            setFormData({
                id: editData?.id || "",
                name: editData?.name || "",
                manufacturer_id: editData?.manufacturer?.id || ""
            });

            if (editData?.manufacturer?.id && editData?.manufacturer?.name) {
                setSelectedManufacturer({
                    label: editData.manufacturer.name,
                    value: editData.manufacturer.id
                });
                
            }

            setIsEditMode(true);
        }
    };

    const onManufacturerChange = (selectedOption) => {
        setSelectedManufacturer(selectedOption);
        setFormData(prev => ({
            ...prev,
            manufacturer_id: selectedOption ? selectedOption.value : ""
        }));
    };

    const submitDataForm = (e) => {
        e.preventDefault();

        if (!formData.manufacturer_id) {
            toast.error("Please select a manufacturer", { position: toast.POSITION.TOP_RIGHT });
            return;
        }

        setSubmitLoading(true);

        if (isEditMode === true) {
            HttpAPICall.withAthorization('PUT', BACKOFFICE_BASE_URL + '/device_model_edit', access_token, {}, formData, (resp) => {
                toast.success(resp.data.msg, { position: toast.POSITION.TOP_RIGHT });
                history.push({ pathname: '/model', state: { id: formData.id } });
            }).then(() => setSubmitLoading(false));
        } else {
            HttpAPICall.withAthorization('POST', BACKOFFICE_BASE_URL + '/device_model_add', access_token, {}, formData, (resp) => {
                toast.success(resp.data.msg, { position: toast.POSITION.TOP_RIGHT });
                backToListing();
            }).then(() => setSubmitLoading(false));
        }
    };

    const formInputHandler = (e) => {
        setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const formDatajsx = () => {
        return (
            <>
                <form className="bg-white p-3" onSubmit={submitDataForm} id="saveResourceForm">
                    <div className="row align-items-center my-3">
                        <div className="col-sm-3">
                            <label htmlFor="name" className="form-label require">Model Name</label>
                        </div>
                        <div className="col-sm-8">
                            <input
                                name="name"
                                type="text"
                                value={formData.name}
                                className="form-control"
                                autoComplete="off"
                                required={true}
                                onChange={formInputHandler}
                                placeholder="Please enter Model Name"
                            />
                        </div>
                    </div>
                    <div className="row align-items-center my-3">
                        <div className="col-sm-3">
                            <label htmlFor="manufacturer" className="form-label require">Manufacturer</label>
                        </div>
                        <div className="col-sm-8">
                            <InputManufacturerSearch
                                placeholder="Select Manufacturer"
                                changeEvent={onManufacturerChange}
                                isClearable={true}
                                value={selectedManufacturer}
                                required={true}
                            />
                        </div>
                    </div>
                    <div className="col-12 text-end fixed_footer">
                        <button type="button" className="btn btn-secondary mx-3" onClick={backToListing} disabled={submitLoading}>Cancel</button>
                        <button type="submit" className="btn btn-primary mx-2" disabled={submitLoading}>
                            Save {submitLoading ? (<TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin" />) : ''}
                        </button>
                    </div>
                </form>
            </>
        );
    };

    const addModelJsx = () => {
        return (
            <>
                <div className="page_title row m0">
                    <div className="col-12">
                        <h3>{isEditMode ? "Edit " : "Add "} Device Model</h3>
                        <div className="text-end mt15">
                            <button type="button" className="btn btn-secondary" onClick={backToListing}>
                                <TapIcon.imageIcon icon={TapIcon.CloseIcon} className="img-fluid" alt="close" />
                            </button>
                        </div>
                    </div>
                </div>
                <div className="container-fluid pl5">
                    <div className="page_containt row">
                        <div className={['pageTbl', 'col-12'].join(' ')}>{formDatajsx()}</div>
                    </div>
                </div>
            </>
        );
    };

    return (
        <ApplicationLayout>
            <Helmet><title>{isEditMode ? "Edit" : "Add"} Device Model</title></Helmet>
            {addModelJsx()}
        </ApplicationLayout>
    );
};

export default IotModelAdd;